import { Directive, Input, OnChanges, SimpleChanges, HostListener, ElementRef, Renderer2, Optional, Host, OnInit, OnDestroy, Output, HostBinding, EventEmitter } from '@angular/core';
import { DropdownContainerComponent } from '../dropdown-container/dropdown-container.component';
import { AutoSuggestOption } from '@otas/utils/custom-components/auto-suggest/auto-suggest.component';
import * as _ from 'underscore';
@Directive({
    selector: '[dropdownItem],dropdownItem',
    standalone: false
})
export class DropdownItemDirective implements OnInit, OnChanges, OnDestroy {
  @Input('dropdownItem') item: AutoSuggestOption;
  @Input() id: any;
  @Input() groupBy: any;
  @Output() select = new EventEmitter<AutoSuggestOption>();
  @HostBinding('class') cssClass = 'show';
  isActive = false;
  isHidden = false;
  constructor(private elementRef: ElementRef, private renderer: Renderer2,
    @Optional() @Host() private dropdownContainer: DropdownContainerComponent) { }
  ngOnChanges(changes: SimpleChanges) {

  }
  ngOnInit() {
    this.dropdownContainer.register(this);

  }
  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
    const childInput = this.dropdownContainer.autocomplete.virtualKeyBoardRef.inputField.elementRef.nativeElement;
    childInput.value = '';
    this.select.emit(this.item);
    (this.dropdownContainer.autocomplete as any).enterKey &&
      (this.dropdownContainer.autocomplete as any).enterKey.focusTonextElementInForm((this.dropdownContainer.autocomplete as any)._elementRef.nativeElement);
  }
  @HostListener('mousedown', ['$event'])
  mousedown(event: MouseEvent) {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
  }
  @HostListener('mouseup', ['$event'])
  mouseup(event: MouseEvent) {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
  }
  @HostListener('mouseenter', ['$event'])
  mouseEnter(event: MouseEvent) {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
    const selectedDropDownItem: DropdownItemDirective = _.find(this.dropdownContainer.dropdownItems, (e: DropdownItemDirective) => e.isActive);
    selectedDropDownItem && selectedDropDownItem.removeHighlight();
    this.highlight();
  }
  selection() {
    this.isActive = true;
    this.removeHighlight();
    this.renderer.addClass(this.elementRef.nativeElement, 'selected');
  }
  removeSelection() {
    this.isActive = false;
    this.renderer.removeClass(this.elementRef.nativeElement, 'selected');
    this.removeHighlight();

  }
  highlight() {
    this.renderer.addClass(this.elementRef.nativeElement, 'highlight');
  }
  removeHighlight() {
    this.renderer.removeClass(this.elementRef.nativeElement, 'highlight');
  }
  scrollIntoView(value) {
    this.elementRef.nativeElement.scrollIntoView(value);
  }
  @HostListener('mouseleave', ['$event'])
  mouseLeave(event: MouseEvent) {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
    this.removeHighlight();

  }
  show() {
    this.renderer.removeClass(this.elementRef.nativeElement, 'hide');
    this.renderer.addClass(this.elementRef.nativeElement, 'show');
    this.isHidden = false;
  }
  hide() {
    this.renderer.addClass(this.elementRef.nativeElement, 'hide');
    this.renderer.removeClass(this.elementRef.nativeElement, 'show');
    this.isHidden = true;

  }
  ngOnDestroy() {
    this.dropdownContainer.unregister(this);
  }
}
